// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1786938443838
      var cssReload = require("/codebuild/output/src1693793820/src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  